export default {
    cycleInformation: 'Cycle information',
    evaluationElements: 'Evaluation elements',
    feedback360Settings: '360 Feedback settings',
    deadlines: 'Deadline dates',
    communications: 'Communications',
    savedAsDraft: 'Feedback cycle saved as a draft.',
    readOnlyNotice: 'This cycle is completed. Its configuration can no longer be changed.',
    managerAssessmentRemoved:
        'Manager Assessment was removed from this cycle because your plan no longer includes Performance PRO. Self-Assessment and 360 Feedback will launch as planned.',
    stepAriaLabel: 'Step {{rank}} of {{total}}: {{label}}',
    stepRankLabel: 'Step {{rank}}',
    pageTitle: '{{name}}, Configuration',
    pageTitleNew: 'New feedback cycle',
    pageSubtitle: 'Configure your feedback cycle.',
};
